import React from 'react';
import { Form } from '@dashboard/components/Formik';
import usePage from '@dashboard/hooks/usePage';

const InvoiceSettingsForm = () => {
  const { page, updatePage } = usePage();

  return (
    <>
      <Form
        enableReinitialize
        initialValues={{
          useCustomBankDetails: !!page?.invoiceSettings?.bankDetails,
          invoiceSettings: {
            dueDays: {
              enabled: page?.invoiceSettings?.dueDays?.enabled || false,
              days: page?.invoiceSettings?.dueDays?.days || 14,
            },
            bankDetails: page?.invoiceSettings?.bankDetails || '',
            additionalInformation: {
              enabled: page?.invoiceSettings?.additionalInformation?.enabled || false,
              title: page?.invoiceSettings?.additionalInformation?.title || '',
              message: page?.invoiceSettings?.additionalInformation?.message || '',
            },
          },
        }}
        fields={({ values, setFieldValue }) => [
          {
            name: 'invoiceSettings.dueDays.enabled',
            type: 'checkbox',
            label: 'Set payment due date',
          },
          {
            name: 'invoiceSettings.dueDays.days',
            type: 'number',
            label: 'Invoice due days',
            inset: true,
            hidden: !values.invoiceSettings.dueDays.enabled,
            required: values.invoiceSettings.dueDays.enabled,
          },
          {
            name: 'useCustomBankDetails',
            label: 'Add bank details',
            type: 'checkbox',
            onClick: event => {
              if (!event.target.checked) {
                setFieldValue('invoiceSettings.bankDetails', '');
                setFieldValue('useCustomBankDetails', false);
              } else {
                setFieldValue('useCustomBankDetails', true);
              }
            },
          },
          {
            name: 'invoiceSettings.bankDetails',
            label: 'Bank details',
            type: 'textarea',
            placeholder: 'Enter bank account details to display on invoices',
            minRows: 3,
            inset: true,
            hidden: !values.useCustomBankDetails,
            required: values.useCustomBankDetails,
          },
          {
            name: 'invoiceSettings.additionalInformation.enabled',
            type: 'checkbox',
            label: 'Add extra information',
          },
          {
            type: 'fieldgroup',
            hidden: !values.invoiceSettings.additionalInformation.enabled,
            inset: true,
            noMargin: false,
            fields: [
              {
                name: 'invoiceSettings.additionalInformation.title',
                label: 'Title',
                type: 'text',
                placeholder: 'e.g. Payment instructions',
                required: values.invoiceSettings.additionalInformation.enabled,
              },
              {
                name: 'invoiceSettings.additionalInformation.message',
                label: 'Message',
                type: 'textarea',
                placeholder: 'Enter additional information to display on invoices',
                minRows: 3,
                required: values.invoiceSettings.additionalInformation.enabled,
              },
            ],
          },
        ]}
        onSubmit={async (values, actions) => {
          const { data, error } = await updatePage.mutateAsync(values);

          if (data) {
            actions.resetForm({
              values: {
                ...values,
                invoiceSettings: {
                  ...values.invoiceSettings,
                  dueDays: {
                    ...values.invoiceSettings.dueDays,
                  },
                },
              },
            });
          }

          return {
            data,
            error,
          };
        }}
      />
    </>
  );
};

export default InvoiceSettingsForm;
